import Styles from "./home.module.css";
import { useEffect, useState } from "react";
import error404Img from "../../images/error404.png";
export const HomeImage     = ( props ) => {
    const { images = [] } = props;
    const { HomeImage   } = Styles;
    const [ image, setImage ] = useState(null);
    useEffect(_=>{
        setImage(images[Math.floor(Math.random() * images.length)]);//to make sure inly one image displayed wit no repeations
    }, []);
    return (
        <div className={ HomeImage }>
            <img src={ image } alt="image"/>
        </div>
    );
};
export const SearchSection = ( props ) => {
    const { search, placeholders } = props;
    const { SearchSection        } = Styles;
    const [ toggleResult, setToggleResult ] = useState( false );
    const [ result,       setResult       ] = useState([]);
    return ( 
        <div className={ SearchSection }>
            <SearchElement 
                search          = { search          }
                setToggleResult = { setToggleResult } 
                setResult       = { setResult       }
                placeholders    = { placeholders    }
            />
            { 
                toggleResult  
                    ? <ResultElement 
                        result     = { result     }
                    />
                    : <OptionsElement /> 
            }
        </div>
    );
};
const SearchElement        = ( props ) => {
    const { search, setToggleResult, setResult, placeholders } = props;
    const { SearchElement } = Styles;

    const [ inputValue,   setInputValue   ] = useState("");
    const removeEmojis = (text) => {
        const emojiPattern = /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2B50}|\u{1F9C0}|\u{1F9D0}-\u{1F9FF}|\u{1F1E6}-\u{1F1FF}|\u{1F004}|\u{1F0CF}|\u{1F1F2}-\u{1F1F3}|\u{1F1E7}-\u{1F1F9}|\u{1F92F}|\u{1F913}|\u{1F60D}|\u{1F61E}|\u{1F62D}|\u{1F636}|\u{1F9B8}-\u{1F9BF}|\u{1F3C8}|\u{1F3C3}|\u{1F3C7}|\u{1F3C9}|\u{1F6B6}|\u{1F6A8}|\u{1F9A0}-\u{1F9A5}|\u{1F9A6}|\u{1F9A7}|\u{1F9A8}|\u{1F9A9}|\u{1F9B2}|\u{1F9B4}|\u{1F9BC}|\u{1F9BF}|\u{1F9C2}|\u{1F9C3}|\u{1F9C4}|\u{1F9C5}|\u{1F9C6}|\u{1F9D2}|\u{1F9D3}|\u{1F9D4}|\u{1F9D5}|\u{1F9D6}|\u{1F9D7}|\u{1F9D8}|\u{1F9D9}|\u{1F9DA}|\u{1F913}]/gu;
        return text.replace(emojiPattern, '').replace(/\s+/g, ' ').trim();
    };
    const onChange = ( event ) => {
        const { value } = event.target;
        setInputValue( value );//update input value
        //filtering the input value and resulting 
        let result = [];
        search.map(( value ) => { 
            const { id, name, category, title, link } = value;
            if(id.replace(/[.,?!;:'"(){}[\]<>@#$%^&*+=_-]/g, '').trim() === removeEmojis(event.target.value).replace(/[.,?!;:'"(){}[\]<>@#$%^&*+=_-]/g, '').trim()){
                result.push({ result: name, title: title, link: link });
            }
            if(removeEmojis(name).replace(/[.,?!;:'"(){}[\]<>@#$%^&*+=_-]/g, '').trim().toLowerCase() === removeEmojis(event.target.value).replace(/[.,?!;:'"(){}[\]<>@#$%^&*+=_-]/g, '').trim().toLowerCase()){
                result.push({ result: name, title: title, link: link });
            }
            if(category.includes(removeEmojis(event.target.value).replace(/[.,?!;:'"(){}[\]<>@#$%^&*+=_-]/g, '').trim().toLowerCase())){
                result.push({ result: name, title: title, link: link });
            }
            if(removeEmojis(title).replace(/[.,?!;:'"(){}[\]<>@#$%^&*+=_-]/g, '').trim().toLowerCase() === removeEmojis(event.target.value).replace(/[.,?!;:'"(){}[\]<>@#$%^&*+=_-]/g, '').trim().toLowerCase()){
                result.push({ result: name, title: title, link: link });
            }
        });
        setResult(result);//update the result element
        value !== "" ? setToggleResult( true ): setToggleResult( false );//toggling the result element considering the input value 
    };
    return (
        <div className={ SearchElement }>
            <i className="bi bi-binoculars-fill"></i>
            <input 
                type        = { "text"                                                        } 
                placeholder = { placeholders[Math.floor(Math.random() * placeholders.length)] }
                onChange    = { e => onChange( e )                                            }
                value       = { inputValue && inputValue                                      }
            />
            <i 
                className = { "bi bi-x-lg" }
                onClick   = { _=>{ setInputValue(""); setToggleResult( false ) } }
            ></i>
        </div>
    );
};
const ResultElement        = ( props ) => {
    const { result        } = props;
    const { ResultElement } = Styles;
    return (
        <div className={ ResultElement }>
            { result.length === 0 && <ErrorNotFound image={ error404Img }/> }
            {
                result.map(( value, key ) => {
                    const { result, title, link } = value;
                    return (
                        <a href={ link } key={ key }>
                            <i className="bi bi-search"></i>
                            <span>{  title  }</span>
                            <span>//{  result  }</span>
                            <i className="bi bi-arrow-right-short"></i>
                        </a>
                    );
                })
            }
        </div>
    );
};
const OptionsElement       = ( props ) => {
    const { } = props;
    const { OptionsElement } = Styles;
    const Options = [
        { icon: <i className="bi bi-newspaper"></i>,            pageName: "Blogs",      theme: "#3F51B5", link: "/blogs" },
        { icon: <i className="bi bi-camera-reels-fill"></i>,    pageName: "Shorts",     theme: "#2196F3", link: "/shorts" },
        { icon: <i className="bi bi-collection-play-fill"></i>, pageName: "Courses",    theme: "#00BCD4", link: "/courses" },
        { icon: <i className="bi bi-grid-fill"></i>,            pageName: "Products",   theme: "#009688", link: "/products" },
        { icon: <i className="bi bi-briefcase-fill"></i>,       pageName: "Projects",   theme: "#4caf50", link: "/projects" },
        { icon: <i className="bi bi-backpack4-fill"></i>,       pageName: "Media",      theme: "#cddc39", link: "/media" },
        { icon: <i className="bi bi-person-vcard-fill"></i>,    pageName: "About Us",   theme: "#ff9800", link: "/about_us" },
        { icon: <i className="bi bi-diagram-3-fill"></i>,       pageName: "Contact Us", theme: "#ff5722", link: "/contact_us" },
        { icon: <i className="bi bi-stars"></i>,                pageName: "Gemini",     theme: "#795548", link: "/gemini" },
    ];
    return (
        <div className={ OptionsElement }>
            {
                Options.map(( value, key ) => {
                    const { icon, pageName, theme, link } = value;
                    return(
                        <a href={ link } key={ key } style={{ color: theme ? theme : "white" }}>
                            { icon }
                            <span>{ pageName }</span>
                        </a>
                    );
                })
            }
        </div>
    );
};
const ErrorNotFound        = ( props ) => {
    const { image } = props;
    const { ErrorNotFound } = Styles;
    return (
        <div className={ ErrorNotFound }>
            <img src={ image }/>
        </div>
    );
};